import React from "react"
import PropTypes from "prop-types"
import ThemeProvider from "@material-ui/styles/ThemeProvider"
import { createTheme } from "@material-ui/core/styles"
import { Box, Paper, Typography } from "@material-ui/core"
import { widgetTableTheme, tableTheme } from "../../../styles"
import MuiDatatablesAdapter from "./MuiDatatablesAdapter"
import ErrorBoundary from "../../../pages/error/ErrorBoundary"
import WidgetErrorFallback from "../WidgetErrorFallback"
import DataTable from "../../tables/DataTable"

/*
 * This component is used to render a Table from passed Widgets from JUMP.
 * It can take a TableProps parameter, which allows it to have customization
 * A TableProps can have "rows" and/or "columns" variables to apply options to every rows and/or columns
 * */

const alterTheme = (theme, hideHeaders) => {
  if (hideHeaders === true) {
    return createTheme({
      ...theme,
      overrides: {
        "MuiTableHead-root": {
          display: "none"
        }
      }
    })
  }
  return theme
}

const Table = (props) => {
  const { data, title: titleProps, TableProps, children } = props
  const title = titleProps || data.title
  const {
    renderTitle,
    columns: columnsOptions,
    options: tableOptions,
    tableTheme: passedTableTheme,
    container: containerProps,
    ...tablePropsRest
  } = TableProps

  const adapter = new MuiDatatablesAdapter(data.data)
  const options = {
    ...adapter.options,
    ...tableOptions
  }
  const hideHeaders = options.hideHeaders || false
  const rows = adapter.mapRows()
  const columns = adapter.mapColumns(columnsOptions)
  const theme = alterTheme(
    widgetTableTheme || passedTableTheme || tableTheme,
    hideHeaders
  )
  return (
    <ErrorBoundary type="Table" FallbackComponent={WidgetErrorFallback}>
      <Box component={Paper} {...containerProps} elevation={0}>
        {renderTitle && renderTitle(title)}
        {/* Show a default title only if the renderTitle is undefined ! If false, that mean the dev doesn't want a title at all */}
        {!renderTitle && renderTitle !== false && (
          <Typography>{title}</Typography>
        )}
        <ThemeProvider theme={theme}>
          <DataTable
            options={options}
            columns={columns}
            data={rows}
            {...tablePropsRest}
          />
          {children}
        </ThemeProvider>
      </Box>
    </ErrorBoundary>
  )
}

Table.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object.isRequired,
  TableProps: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}
Table.defaultProps = {
  title: undefined,
  TableProps: {},
  children: undefined
}

export default Table
